import React from 'react';
import styled, { css, keyframes } from 'styled-components';

import { CalendarButton } from './CalendarButton';
import CalendarIconSVG from './CalendarIconSVG';

type calendarIconProps = Partial<CalendarButton> & { hasTheCalendarOpened: boolean };

const calendarIconOpenAnimation = keyframes`
  0% { transform: translateX(-360px); }
  100% { transform: translateX(0); }
`;

const calendarIconCloseAnimation = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-360px);}
`;

const CalendarIconWrapper = styled.div<calendarIconProps>`
  height: 17px;
  margin-right: -3px;
  width: 19px;
  overflow: hidden;

  svg {
    animation-duration: 300ms;
    animation-fill-mode: forwards;
    animation-timing-function: steps(18);
    animation-name: ${calendarIconOpenAnimation};

    ${props =>
      props.disabled &&
      css`
        opacity: 0.5;
      `}

    ${props =>
      props.calendarOpen &&
      css`
        animation-name: ${calendarIconCloseAnimation};
      `}

    ${props =>
      !props.calendarOpen &&
      props.hasTheCalendarOpened &&
      css`
        animation-name: ${calendarIconOpenAnimation};
      `}
  }
`;

const CalendarIcon = (props: calendarIconProps) => (
  <CalendarIconWrapper {...props}>
    <CalendarIconSVG />
  </CalendarIconWrapper>
);

export default CalendarIcon;
